import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function HollowStar(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12 .574c-1.03 0-2.059.513-2.57 1.534a1.418 1.418 0 0 0-.006 0L7.27 6.424c-.002.003-.01.013-.028.016l-4.83.693a1.418 1.418 0 0 0-.006 0c-2.252.325-3.23 3.295-1.584 4.874l3.495 3.357.006.005-.826 4.736c-.392 2.255 2.138 4.065 4.16 3.014l4.315-2.238a.06.06 0 0 1 .05 0l4.32 2.238c2.023 1.05 4.551-.754 4.16-3.008a1.418 1.418 0 0 0 0-.006l-.825-4.736.006-.005 3.495-3.357c1.646-1.58.668-4.55-1.584-4.874a1.418 1.418 0 0 0-.006 0l-4.83-.693c-.019-.003-.025-.011-.028-.016l-2.16-4.316C14.06 1.087 13.03.574 12 .574Zm-.039 2.803c.045-.09.033-.09.078 0l2.16 4.315a2.876 2.876 0 0 0 2.16 1.551l4.83.698c.086 0 .094-.047.023.022l-3.496 3.357a2.851 2.851 0 0 0-.83 2.537l.825 4.736c.016.09.05.069-.061.01l-4.32-2.237a2.889 2.889 0 0 0-2.66 0l-4.32 2.238c-.112.058-.077.079-.06-.011l.824-4.736a2.851 2.851 0 0 0-.83-2.537L2.788 9.963c-.071-.069-.063-.022.022-.022l4.83-.698a2.874 2.874 0 0 0 2.166-1.551Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </IconWrapper>
  );
}
